define(function (require) {

    require('app/module/System/extension/validator/additionalRules');

    $.extend($.validator.messages, {
        required: "Povinné pole.",
        maxlength: $.validator.format("Maximálne {0} znakov."),
        minlength: $.validator.format("Minimálne {0} znakov."),
        rangelength: $.validator.format("Minimálne {0} a Maximálne {1} znakov."),
        email: "Neplatná emailová adresa.",
        url: "Neplatná URL.",
        date: "Nesprávny formát dátumu.",
        dateeu: "Nesprávny formát dátumu",
        number: "Pole musí obsahovať číslo.",
        digits: "Pole môže obsahovať iba číslice.",
        equalTo: "Hodnoty sa nerovnajú.",
        range: $.validator.format("Musí byť v rozmedzí {0} a {1}."),
        max: $.validator.format("Nemôže byť viac ako{0}."),
        min: $.validator.format("Nemôže byť menej ako{0}."),
        creditcard: "Číslo platobnej karty musí byť platné.",
        personalidentificationnumber: "Neobsahuje platné rodné číslo.",
        regnumber: "Nesprávny formát IČO.",
        taxregnumber: "Nesprávny formát IČ DPH.",
        time: "Nesprávny formát dátumu.",
        datetime: "Nesprávny formát dátumu a času.",
        boolean: "Pole môže obsahovať iba hodnoty ÁNO/NIE.",
    });
});